import mixpanel from 'mixpanel-browser';
import { START_SESSION_RECORDING_EVENT, STOP_SESSION_RECORDING_EVENT } from '../../../helpers/constants';

/**
 * A simple class wrapper around Mixpanel's browser API.
 * @property {Object} configuration Configuration.
 * @property {String} configuration.userId The user's ID.
 * @property {String} configuration.userGuid The user's GUID.
 * @property {Object} configuration.baseProperties Base properties to merge with each event.
 * @property {String} configuration.token Mixpanel token.
 * @property {Number} [configuration.recordSessionPercent] Mixpanel record session percentage.
 * @property {Boolean} [configuration.recordHeatmapData] Mixpanel Heatmap data collection.
 * @return {Object} Mixpanel decorator.
 */
const Mixpanel = ({
    baseProperties = {},
    userId,
    userGuid,
    token,
    recordSessionPercent = 0,
    recordHeatmapData,
    brazeExternalUserId
} = {}) => {
    mixpanel.init(token, {
        disable_persistence: true,
        record_sessions_percent: recordSessionPercent,
        record_mask_text_selector: '',
        record_heatmap_data: recordHeatmapData
    });

    if (userGuid) {
        mixpanel.register({
            $device_id: userGuid,
            distinct_id: userGuid
        });
    }
    const mixpanelAliasStorageKey = `mixpanel_alias_done_${userId}`;

    if (userId) {
        if (brazeExternalUserId && !localStorage.getItem(mixpanelAliasStorageKey)) {
            mixpanel.alias(brazeExternalUserId, userId);
            localStorage.setItem(mixpanelAliasStorageKey, 'true');
        }
        mixpanel.identify(userId);
    }

    if (brazeExternalUserId) {
        mixpanel.people.set({
            $braze_external_id: brazeExternalUserId
        });
    }
    const track = (eventName, properties = {}) => {
        const payload = {
            ...baseProperties,
            ...properties
        };

        mixpanel.track(eventName, payload);
    };

    const startSessionRecording = () => {
        mixpanel.track(START_SESSION_RECORDING_EVENT);
        mixpanel.start_session_recording();
    };
    const stopSessionRecording = () => {
        mixpanel.track(STOP_SESSION_RECORDING_EVENT);
        mixpanel.stop_session_recording();
    };

    return {
        track,
        startSessionRecording,
        stopSessionRecording
    };
};

export default Mixpanel;
